function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, [{
    key: "execute",
    value: function execute(properties, params, component) {
      Utils.http.startIndicator(component);
      var stripe = Stripe(properties.publicKey);

      if (properties.setupOnly) {
        stripe.confirmCardSetup(properties.clientSecret).then(function (result) {
          Utils.http.stopIndicator(component);

          if (result.error) {
            GLib.action.execute(properties.onFailure, component);
          } else {
            GLib.action.execute(properties.onSuccess, component);
          }
        });
      } else {
        stripe.handleCardAction(properties.clientSecret).then(function (result) {
          Utils.http.stopIndicator(component);

          if (result.error) {
            GLib.action.execute(properties.onFailure, component);
          } else {
            GLib.action.execute(properties.onSuccess, component);
          }
        });
      }
    }
  }]);

  return _default;
}();

export { _default as default };